<template>
  <div class="StatisticsTemp" :style="color ? 'background-color:' + color : ''">
    <el-row class="inner">
      <el-col>
        <div class="labelTitle">地域</div>
        <el-cascader v-model="areaOrgCode" ref="cascaderRef" :options="areaList" clearable placeholder="请选择"
          style="width: 110px;" :props="propsConfig" :show-all-levels="false" @change="cascaderChange">
        </el-cascader>
      </el-col>
      <el-col>
        <div class="labelTitle">层级</div>
        <el-select v-model="searchParam.hierarchy" placeholder="请选择" @change="levelChange" style="width: 100px;">
          <el-option key="本级" label="本级" value="selfHierarchy" />
          <el-option key="全部" label="全部" value="all" />
        </el-select>
      </el-col>
      <el-col>
        <div class="labelTitle">方式</div>
        <my-select :value.sync="searchParam.inspectionMethod" categoryCode="inspectionMethod" parentId="" type="xs" />
      </el-col>
      <el-col v-show="!isSelfHierarchy">
        <div class="labelTitle">统计开始</div>
        <el-date-picker v-model="searchParam.startDate" type="date" placeholder="选择日期" style="width: 140px;"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-col>
      <el-col v-show="!isSelfHierarchy">
        <div class="labelTitle">统计结束</div>
        <el-date-picker v-model="searchParam.endDate" type="date" placeholder="选择日期" style="width: 140px;"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-col>
      <el-col v-show="isSelfHierarchy">
        <div class="labelTitle">届次</div>
        <el-select v-model="searchParam.numberOfSessions" clearable placeholder="请选择" style="width: 110px;">
          <el-option v-for="item in periodSize" :key="item" :label="'第' + num2text(item) + '届'"
            :value="'第' + item + '届'" />
        </el-select>
      </el-col>
      <el-col v-show="isSelfHierarchy">
        <div class="labelTitle">轮次</div>
        <el-select v-model="searchParam.rounds" clearable placeholder="请选择" style="width: 110px;">
          <el-option v-for="item in roundSize" :key="item" :label="'第' + num2text(item) + '轮'"
            :value="'第' + item + '轮'" />
        </el-select>
      </el-col>
      <el-col>
        <div class="labelTitle">单位类型</div>
        <el-select v-model="searchParam.inspectionUnitType" @change="getDeptList" multiple clearable placeholder="请选择"
          style="width: 110px;">
          <el-option v-for="(item, inx) in inspectionUnitType" :key="inx" :label="item.name" :value="item.code">
          </el-option>
        </el-select>

        <!--   <my-select style="display: inline-block" categoryCode="inspectionUnitType"
          :value.sync="searchParam.inspectionUnitType" parentId="" type="xs" /> -->

      </el-col>
      <el-col>
        <div class="labelTitle">单位</div>
        <el-select v-model="searchParam.inspectedUnitName" clearable multiple placeholder="请选择单位" style="width: 130px;">
          <el-option v-for="(item, inx) in deptList" :key="inx" :label="item.name" :value="item.name" />
        </el-select>
      </el-col>
      <el-col>
        <div class="labelTitle">单位名称</div>
        <el-input v-model.trim="searchParam.unitName" width="140px" maxlength="18" placeholder="请输入内容"></el-input>
      </el-col>
      <el-col>
        <slot name="btn"></slot>
        <el-button icon="el-icon-search" size="small"  @click="doMainQuery" round>查询</el-button>
        <el-button v-if="showCut" icon="el-icon-sort" size="small"  @click="$emit('cut')" round>图表切换</el-button>
      </el-col>
    </el-row>

    <div class="cont">
      <slot />
    </div>
  </div>
</template>
<script>
  /**
   * 查询组件2021/09/08 by wqy
   */
  import { getDeptNameList, getDeptTypeList } from '@/api/IntegrityArchives.js';
  import { getAreaList } from '@/api/workDesk.js';

  export default {
    name: 'StatisticsTemp',
    props: {
      showCut: {
        type: Boolean,
        default: false
      },
      color: String,
      plusParam: Object // 子组件额外传参,用于同步参数
    },
    data() {
      return {
        searchParam: {
          inspectionMethod: this.$store.state.app.inspectionMethod, // 巡视方式
          hierarchy: this.$store.state.app.hierarchy, // 层级，默认本级
          startDate: '', // 开始时间
          endDate: '', // 结束时间

          numberOfSessions: this.$store.state.app.jieci, // 届次
          rounds: this.$store.state.app.lunci, // 轮次

          unitName: '', // 单位名称
          inspectionUnitType: [], // 巡视单位类型（多选）
          inspectedUnitName: [] // 巡视单位（多选）
        },

        areaList: [],
        areaOrgCode: '',
        areaOrgName: '',

        periodSize: 20,
        roundSize: 25,
        deptList: [],

        inspectionUnitType: []
      };
    },
    created() {
      // 级联数据配置项(非响应式数据)
      this.propsConfig = {
        expandTrigger: 'hover',
        emitPath: false,
        checkStrictly: true,
        value: 'innerCode',
        label: 'name',
        children: 'children'
      };
      this.getAreaList();
    },
    computed: {
      // 层级是否本级
      isSelfHierarchy() {
        return this.$store.state.app.hierarchy == 'selfHierarchy'
      },
      JIELUNchange() {
        let numberOfSessions = this.searchParam.numberOfSessions;
        let rounds = this.searchParam.rounds
        return {
          numberOfSessions,
          rounds
        }
      }
    },
    watch: {
      plusParam(object) {
        // console.log('jtd')
        if (object) {
          for (let key in object) {
            // this.searchParam[key] = object[key];
            this.$set(this.searchParam, key, object[key])
          }
        }
      },
      'searchParam.inspectionMethod'(val) {
        this.$store.commit('setInspectionMethod', val)
      },
      JIELUNchange(val) {
        this.$store.commit('setJieci', val.numberOfSessions)
        this.$store.commit('setLunci', val.rounds)
        this.getDeptList()
      }
    },
    methods: {
      // getInspectMethod(val) {
      //   return this.$options.filters["dictConverFilter"]("code", "name", val, CategoryMapPaiZu, "inspectionMethod")
      // },
      doMainQuery() {
        this.$emit('query', this.handleQueryParams()) // 查询时将处理的参数对象传回
      },
      // 地域下拉数据
      getAreaList() {
        let Material = this.$store.state.offlineMaterial;
        let areaList = Material.areaList;
        this.areaOrgCode = Material.areaOrgCode;
        this.areaOrgName = Material.areaOrgName;

        if (areaList.length) {
          this.areaList = areaList;
          if (!this.areaOrgCode) { // 如果为空,则使用默认第一级
            this.areaOrgCode = areaList[0].innerCode
            this.areaOrgName = areaList[0].name

            this.$store.commit('setAreaOrgCode', this.areaOrgCode);
            this.$store.commit('setAreaOrgName', this.areaOrgName);
          }
          this.getDeptList();
          this.getDeptTypeList();
          this.doMainQuery(); // 用于引用组件的页面初始化数据
        } else {
          getAreaList({}).then((res) => {
            this.areaList = res.data
            if (!this.areaOrgCode) { // 如果为空,则使用默认第一级
              this.areaOrgCode = this.areaList[0].innerCode
              this.areaOrgName = this.areaList[0].name

              this.$store.commit('setAreaList', this.areaList);
              this.$store.commit('setAreaOrgCode', this.areaOrgCode);
              this.$store.commit('setAreaOrgName', this.areaOrgName);
            }
            this.getDeptList();
            this.getDeptTypeList();
            this.doMainQuery();
          });
        }
      },
      // 地域切换事件
      cascaderChange(e) {
        // 同时获取value与label
        let node = this.$refs.cascaderRef.getCheckedNodes();
        this.areaOrgName = node[0].label;
        this.areaOrgCode = node[0].value;
        this.$store.commit('setAreaOrgCode', this.areaOrgCode);
        this.$store.commit('setAreaOrgName', this.areaOrgName);

        this.$refs.cascaderRef.toggleDropDownVisible();
        this.getDeptList();
        this.getDeptTypeList();
      },
      // 层级切换事件
      levelChange(e) {
        this.$store.commit('setHierarchy', e);
        this.getDeptList();
        this.getDeptTypeList();
      },
      // 获取单位列表数据
      getDeptList() {
        let param = this.handleQueryParams();
        getDeptNameList(param).then((res) => {
          this.deptList = res.data;
        });
      },
      // 获取单位类型数据
      getDeptTypeList() {
        let params = {
          'orgInnerCode': this.areaOrgCode,
          'hierarchy': this.searchParam.hierarchy
        }
        getDeptTypeList(params).then((res) => {
          this.inspectionUnitType = res.data;
        });
      },
      /**
       * 当前参数处理转换
       */
      handleQueryParams() {
        let copy = JSON.parse(JSON.stringify(this.searchParam));

        if (!this.isSelfHierarchy) { // 层级选择全部时，传参时置空轮次届次，传递起止时间
          copy.numberOfSessions = ''
          copy.rounds = ''
        } else { // 层级选择本级时，不传递起止时间
          copy.startDate = undefined
          copy.endDate = undefined
        }

        copy.orgInnerCode = this.areaOrgCode;
        copy.orgBranchName = this.areaOrgName;
        copy.inspectionUnitType = copy.inspectionUnitType.join(',');
        copy.inspectedUnitName = copy.inspectedUnitName.join(',');

        return copy;
      },
      // 数字转文本
      num2text(num) {
        return this.$options.filters.num2text(num)
      }
    }
  };
</script>
<style scoped lang="less">
  .StatisticsTemp {
    width: 100%;
    height: 100%;
    padding-right: 6px;
    background-color: #fff;

    .labelTitle {
      display: inline-block;
      margin-right: 6px;
    }

    .inner {
      line-height: 60px;
      display: flex;
      flex-wrap: wrap;
      >.el-col {
        margin-left: 10px;
        color: rgba(101, 101, 101, 1);
        display: flex;
        align-items: center;
        width: auto;
        white-space: nowrap;
      }

      .el-select {
        flex: 1;
      }

      .el-button {
        // background-color: rgba(57, 119, 220, 1);
        border-color: #409EFF;
        color: #409EFF;
      }
    }

    .cont {
      height: calc(100% - 60px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StatisticsTemp.vue